import React, { useEffect, useMemo, useState } from "react";
import styles from "./PubblicitaDettaglio.module.css";
import { getAdvertisementById } from "@logic/advertising";
import { useNavigator } from "@contexts/NavigatorContext";

const PubblicitaDettaglio = () => {
  const { currentRoute } = useNavigator();
  const [advertisement, setAdvertisement] = useState(null);

  const advertisementId = useMemo(() => currentRoute?.params?.[0], [currentRoute?.params]);

  useEffect(() => {
    if (advertisementId) {
      setAdvertisement(getAdvertisementById(advertisementId));
    }
  }, [advertisementId]);

  if (!advertisement) {
    return (
      <div className="row">
        <div className="col">
          <span className="page-title">Pubblicità non trovata</span>
          <p>Verifica che il link sia corretto o che la pubblicità non sia scaduta.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="row">
      <div className="col">
        <div className={styles.wrapper}>
          <img
            src={advertisement.destinationImage || advertisement.seamlessImage || advertisement.bannerImage}
            alt={advertisement.seamlessTitle || "Pubblicità"}
            className={styles.hero}
          />
          <div className={styles.content}>
            <span className="page-title">{advertisement.seamlessTitle || advertisement.businessName}</span>
            <p className={styles.business}>{advertisement.businessName}</p>
            <p>{advertisement.seamlessText || "Pubblicità sponsorizzata"}</p>
            <div className={styles.meta}>
              {advertisement.categories?.length > 0 && (
                <span>Categoria: {advertisement.categories.join(", ")}</span>
              )}
              {advertisement.expirationDate && (
                <span>Valida fino al {advertisement.expirationDate}</span>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PubblicitaDettaglio;
